<h1 mat-dialog-title>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.TITLE' | translate: { value: data.lesson.id } }}</h1>

<div mat-dialog-content>
  
  <p>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.CONCLUSION' | translate }}</p>

  <div fxLayout="row" >
    <!-- results -->
    <div fxLayout="column" fxLayoutAlign="start start" class="result-info-container" fxFlex="50">
          
      <div><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.LESSON' | translate }}:</label> <strong><span>{{data.lesson.id}}</span></strong></div>
      <div><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.TIME.ELAPSED' | translate }}:</label><strong><span>{{timeElapsed}}</span></strong></div>
      <div *ngIf="language==='uk'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.WPM' | translate }}:</label><strong><span>{{wpm}}</span></strong></div>
      <div *ngIf="language==='uk'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.ACCURACY' | translate }}:</label><strong><span>{{accuracy}}</span></strong></div>

      <div *ngIf="language==='dk'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.WPM' | translate }}:</label><strong><span>{{apm.toFixed(2)}}</span></strong></div>
      <div *ngIf="language==='dk'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.ACCURACY' | translate }}:</label><strong><span>{{errorPercentage.toFixed(2)}}</span></strong></div>

      <div *ngIf="language==='de'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.WPM' | translate }}:</label><strong><span>{{wpm}}</span></strong></div>
      <div *ngIf="language==='de'"><label>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.ACCURACY' | translate }}:</label><strong><span>{{accuracy}}</span></strong></div>

      <!-- grade -->
    </div>

    <!-- video -->
    <div fxFlex="50">
      <video #videoPlayer class="video" controls autoplay>
        <source [src]="video" type="video/mp4">
        Your browser does not support the video tag.
      </video>  
    </div>

  </div>

</div>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'ADVANCEDLESSON.RESULTS.DIALOG.CONTINUE' | translate }}</button>
</div>